import { client } from "../../../api/client"
import { getUserByEmail, getNextUserId, addUser } from './localUserStore'
import { getByCompanyAndEntity, addDefaultCompanyEntity } from '../../../data/companyEntities/data/localCompanyEntitiesStore';

export const fetchUser = async (email, addingNewUserInLocalMode = false) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        // When logging in locally, create a user in the local store if it doesn't already exist. This
        // allows the user who is logged in to display in the UI, rather than the same default user
        // always showing whoever actually logs in. However, this method is also called to check for
        // existing users when adding new users, so in that case we don't want to auto-create a user.
        try {
            const existing = await getUserByEmail(email)
            if (existing) return existing

            // If we're inviting a new user in local mode, return null here so that
            // the New User dialog doesn't think that the user already exists
            if (addingNewUserInLocalMode) return { id: 0 }

            // Derive names from the email local-part (before @) using '.' as delimiter
            const localPart = String(email || '').split('@')[0] || ''
            const parts = localPart.split('.').filter(Boolean)
            const firstRaw = parts.length ? parts[0] : localPart
            const lastRaw = parts.length ? parts[parts.length - 1] : ''
            const capitalize = (s) => {
                if (!s) return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            }
            const firstName = capitalize(firstRaw)
            const lastName = capitalize(lastRaw)

            const id = await getNextUserId()
            const created = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString()

            const newUser = {
                id: id,
                created: created,
                userName: email,
                firstName: firstName,
                lastName: lastName,
                emailAddress: email,
                avatar: '0.jpg',
                areaId: 0,
                locked: false,
                disabled: false,
                deleted: false
            }

            await addUser(newUser)
            // Also add a default company entity entry mapping this new user to companyId 1
            try {
                const existingCompanyEntity = await getByCompanyAndEntity(1, id);
                if (!existingCompanyEntity) {
                    await addDefaultCompanyEntity({
                        companyId: 1,
                        entityId: id,
                        roleId: 4,
                        isDefault: true
                    })
                }
            } catch (err) {
                console.error('Error adding default company entity for new user:', err)
            }
            return newUser
        } catch (e) {
            console.error('Error using local user store for fetchUser:', e)
            return null
        }
    } else {

        const payload = JSON.stringify(
            {
                "emailAddress": email
            }
        )

        const responseUser = await client.post("users/users/fetchUser", payload)
        return responseUser.data
    }
};